"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomsStatusActivityContent = void 0;
var StatusTerm;
(function (StatusTerm) {
    StatusTerm["GOODS_ARRIVED"] = "goods-arrived";
    StatusTerm["INSPECTION_REQUIRED"] = "inspection-required";
    StatusTerm["DOCUMENT_INSPECTION"] = "document-inspection";
    StatusTerm["PHYSICAL_INSPECTION"] = "physical-inspection";
    StatusTerm["CUSTOMS_CLEARED"] = "customs-cleared";
})(StatusTerm || (StatusTerm = {}));
const codeToStatusTermMap = {
    40: StatusTerm.GOODS_ARRIVED,
    41: StatusTerm.GOODS_ARRIVED,
    53: StatusTerm.INSPECTION_REQUIRED,
    '09': StatusTerm.CUSTOMS_CLEARED,
    54: StatusTerm.CUSTOMS_CLEARED,
    60: StatusTerm.CUSTOMS_CLEARED,
    CUSTOMS_GOODS_RELEASED: StatusTerm.CUSTOMS_CLEARED,
    CUSTOMS_DOCUMENTATION_EXAM: StatusTerm.DOCUMENT_INSPECTION,
    CUSTOMS_PHYSICAL_EXAM: StatusTerm.PHYSICAL_INSPECTION,
};
const getCustomsStatusActivityContent = ({ activity }) => {
    const term = `activity-feed_customs_status_${codeToStatusTermMap[activity.statusCode]}${activity.containerNumbers.length > 0 ? '' : '_lcl'}`;
    const params = {
        shipmentId: activity.referenceId,
        containerNumbers: activity.containerNumbers.join(', '),
    };
    return { term, params };
};
exports.getCustomsStatusActivityContent = getCustomsStatusActivityContent;
//# sourceMappingURL=getCustomsStatusActivityContent.js.map